export default __webpack_public_path__ + "static/media/favourite.5b91fd17.svg";